import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule } from '@angular/forms';
import { LayoutsModule } from 'src/app/layouts/layouts.module';
import { ReportAdministrationComponent } from './report-administration/report-administration.component';
import {
  DxButtonModule,
  DxDataGridModule,
  DxDateBoxModule,
  DxFileUploaderModule,
  DxFormModule,
  DxLoadIndicatorModule,
  DxLoadPanelModule,
  DxScrollViewModule,
  DxSelectBoxModule,
} from 'devextreme-angular';
import { ReportsRouting } from './reports-routing.module';
import { ButtonWithIndicatorModule, ModalWindowModule } from 'ag-common-svc/public-api';
import { SharedModule } from 'ag-common-svc/shared/shared.module';

@NgModule({
  declarations: [ReportAdministrationComponent],
  imports: [
    ReportsRouting,
    CommonModule,
    SharedModule,
    FormsModule,
    LayoutsModule,
    DxButtonModule,
    DxSelectBoxModule,
    DxFileUploaderModule,
    DxDateBoxModule,
    DxScrollViewModule,
    DxDataGridModule,
    DxFormModule,
    DxLoadIndicatorModule,
    DxLoadPanelModule,
    ButtonWithIndicatorModule,
    ModalWindowModule,
  ],
  exports: [],
})
export class ReportsModule {}
